import { render, staticRenderFns } from "./NavbarItems.vue?vue&type=template&id=c87b4868&scoped=true"
import script from "./NavbarItems.vue?vue&type=script&lang=js"
export * from "./NavbarItems.vue?vue&type=script&lang=js"
import style0 from "./NavbarItems.vue?vue&type=style&index=0&id=c87b4868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87b4868",
  null
  
)

export default component.exports